import { parse } from 'query-string';
import { onSaleParam } from './helpers';
import Departments from '../models/departments';

export const api = {
  newsletterSignup: '/api/newsletter/subscribe',
};

export const canonicalBaseUrl = 'https://www.italist.com';
export const reviews = '/reviews/';
export const aboutUs = '/about_us/';
export const cart = '/cart/';
export const charitableGiving = '/charitable_giving/';
export const contactUs = '/contact_us/';
export const ipForm = '/contact_us/ip_form/';
export const press = '/press/';
export const privacy = '/privacy/';
export const customerService = '/customer_service/';
export const howToShop = '/customer_service/#how_to_shop';
export const ordersAndShipping = '/customer_service/#orders_and_shipping';
export const serviceUpdates = '/customer_service/#service_updates';
export const returnsAndRefunds = '/customer_service/#returns_and_refunds';
export const returnsPolicy = '/customer_service/#returns_policy';
export const promotionsPolicy = '/customer_service/#promotions_policy';
export const faq = '/customer_service/#faq';
export const recoverPassword = '/recover_password/';
export const termsAndCondition = '/terms/';
export const home = '/';
export const signup = '/signup/';
export const magazine = 'https://www.italist.com/magazine/';
export const brandsUrl = '/brands';
export const ourPromise = '/our_promise/';
export const italistLegit = '/is_italist_legitimate/';
export const womenSearchUrl = '/women/?q=';
export const italistByYou = '/italist_by_you/';

export const linkedIn = 'https://www.linkedin.com/company/italist-com/';
export const angeListJobs = 'https://angel.co/italist/jobs';
export const crunchbase = 'https://www.crunchbase.com/organization/italist';
export const bbb = 'https://www.bbb.org/us/ca/los-angeles/profile/online-retailer/italistcom-1216-902411';

export const menUrlNewInSale = (sale = false) => `/men/${sale ? `?${onSaleParam}` : ''}`;
export const womenUrlNewInSale = (sale = false) => `/women/${sale ? `?${onSaleParam}` : ''}`;
export const kidsUrlNewInSale = (sale = false) => `/kids/${sale ? `?${onSaleParam}` : ''}`;

export const search = (department, query) => `/${department}/?q=${encodeURIComponent(query)}`;

export const buildBrandUrl = ({ brandUrl, department }: { brandUrl: string; department: string }) => {
  const topDepartment = Departments.getKidsDepartmentsInternalNames().includes(department)
    ? Departments.getKidsInternalName()
    : department;
  return `${brandUrl}/${topDepartment ? `${topDepartment}/` : ''}`;
};

export const buildBrandUrlWithCategory = ({
  brandUrl,
  department,
  categoryId,
}: {
  brandUrl: string;
  categoryId: string;
  department: string;
}) => `${buildBrandUrl({ brandUrl, department })}?categories%5B%5D=${categoryId}`;

export const buildBreadCrumbUrl = url => url.replace(/^\/?(en)?\/?/, '/');

export const getRedirectPath = ({ account }, localized) => {
  const { redirect } = parse(window.location.search);
  switch (redirect) {
    case 'cart':
      return localized(cart);
    case 'myaccount':
      return account;
    default:
      return redirect;
  }
};

export const isHomePage = () => {
  const regexr = /^\/[a-zA-Z]{2}\/?(\?.*)?$/;
  return window.location && window.location.pathname && regexr.test(window.location.pathname);
};
